import React from 'react'
import './ErrorsPopup.css'

function ErrorsPopup({onClose, text, isOpen}) {
  

  return (
    
    <div className={`errors-popup ${isOpen && 'errors-popup__opened'}`}>

        <div className="errors-popup__container">
            <button 
                className="errors-popup__close-button" 
                type="button" 
                onClick={onClose}>
            </button>
            <div className="errors-popup__text-container">
                <h2 className="errors-popup__title">Ошибка</h2>
                <p className='errors-popup__text-of-error'>{text}</p>
            </div>

        </div>
    </div>
  )
}

export default ErrorsPopup;